module.exports = __webpack_public_path__ + "media/img/clients/client6-6c0f99f333577c7c3849e56963a618cb.svg";